import { GridColumnStyles } from '@common/common';
import { OrderCustomerRenderer } from '@common/order-customer-renderer';
import { ensureObject } from '@util/utils';

export class C {
  data: any = {};

  f(f: string) {
    this.data.field = f;
    return this;
  }
  h(hn: string) {
    this.data.headerName = hn;
    return this;
  }
  min(minWidth: number) {
    this.data.minWidth = minWidth;
    return this;
  }
  max(maxWidth: number) {
    this.data.maxWidth = maxWidth;
    return this;
  }
  w(width: number) {
    this.data.width = width;
    return this;
  }
  cc(cellClass: string) {
    this.data.cellClass = cellClass;
    return this;
  }
  csc() {
    return this.cc(GridColumnStyles.CELL_CLASS_STRING);
  }
  cic() {
    return this.cc(GridColumnStyles.CELL_CLASS_INT);
  }
  add(obj: any) {
    this.data = Object.assign(this.data, obj);
    return this;
  }
}

/**
 *
 * @param field
 * @returns
 */
export function createColDef(field: string) {
  const res = new C();
  res.f(field);
  return res;
}

export const statusColumn = createColDef('status_name')
  .h('Status')
  .min(100)
  .max(120)
  .csc().data;

  export const infoColumn = createColDef('info')
  .h('Hinweis')
  .min(120)
  .max(180)
  .add({flex:1})
  .cc('green-text').data;

export const teamColumn = createColDef('team_name').h('Team').min(140).add({
  flex: 1,
}).data;

export const enum ID_CLASS_CLASSES {
  RECEIPT_PRINTED = 'id-for-receipt-printed',
  NO_DEDUCTIBLE = 'id-for-no-deductible',
}

export const orderNrColumnForAdmin = {
  field: 'id',
  headerName: 'ID',
  width: 60,
  cellClass: GridColumnStyles.CELL_CLASS_INT,
  cellRenderer: (params: any) => {
    const d = ensureObject(params.data);
    const cls = d.rp
      ? ID_CLASS_CLASSES.RECEIPT_PRINTED
      : d.nd
      ? ID_CLASS_CLASSES.NO_DEDUCTIBLE
      : '';
    return '<span class="' + cls + '">' + params.value + '</span>';
  },
};

export const orderNrColumnForMontage = {
  field: 'id',
  headerName: 'ID',
  width: 80,
  cellClass: GridColumnStyles.CELL_CLASS_INT,
};

export const docIdColumnForTrash = {
  field: 'id',
  headerName: 'Dok-ID',
  width: 80,
  cellClass: GridColumnStyles.CELL_CLASS_INT,
};


export const deleteDateColumn = {
  field: 'rm_date',
  headerName: 'Löschdatum',
  minWidth: 120,
  maxWidth: 160,
};

export const trashOrderDateColumn = {
  field: 'workday',
  headerName: 'Datum',
  minWidth: 120,
  maxWidth: 160,
};

export const orderDateColumn = {
  field: 'work_day',
  headerName: 'Datum',
  minWidth: 120,
  maxWidth: 160,
};

export const orderDateColumnForTrash = {
  field: 'work_day',
  headerName: 'Datum (Auftrag)',
  minWidth: 120,
  maxWidth: 160,
};

export const customerColumn = {
  field: 'customer',
  headerName: 'Kunde',
  cellRenderer: OrderCustomerRenderer,
  flex: 1,
  minWidth: 200,
};

export const licensePlateColumn = {
  field: 'plate',
  headerName: 'Kennzeichen',
  minWidth: 100,
};

export const partnerColumn = {
  field: 'partner_name',
  headerName: 'Partner',
  flex: 1,
  minWidth: 150
};

export const insuranceColumn = {
  field: 'insurance',
  headerName: 'Versicherung',
  minWidth: 100,
  flex: 1,
};

export const kindColumn = {
  field: 'kind',
  headerName: 'Fahrzeugart',
  minWidth: 80,
  maxWidth: 150,
};
